<template>
    <div class="wrap-accordions">
        <v-expansion-panels v-model="expanded" focusable>
            <v-expansion-panel
                active-class="activ-accordions"
                class="wrap-accordions-element"
            >
                <v-expansion-panel-header :class="{ primary : expanded === 0 }">
                    <v-row align="center">
                        <v-col cols="12" md="6">
                            <span class="title-load">
                                <v-icon>mdi-truck</v-icon>
                                {{ $t("tours.loading") }}
                            </span>
                        </v-col>
                        <v-col class="d-flex align-center" cols="12" md="6">
                            <span :class="getLoading(tour.loading_state.code)"
                                  class="load-status">
                                <v-icon>{{
                                        `mdi-${getLoadingIcon(tour.loading_state.code)}`
                                    }}</v-icon>
                                <span>
                                    {{
                                        $t(`loading_states.${tour.loading_state.code}`)
                                    }}
                                </span>
                            </span>
                            <span class="load-date">
                                <span v-if="tour.loadings_updated_at">
                                    {{
                                        tour.loadings_updated_at.toDateTime()
                                    }}
                                </span>
                            </span>
                        </v-col>
                    </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="wrap-detail">
                    <v-row>
                        <v-col cols="12">
                            <v-data-table
                                :headers="headers"
                                :item-class="getRowBgClass"
                                :items="missing_loadings"
                                :items-per-page="-1"
                                hide-default-footer
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                            >
                                <template #[`item.actions`]>
                                    <v-btn
                                        class="delete ma-1"
                                        icon
                                        small
                                        dark
                                    >
                                        <v-icon size="16">mdi-delete</v-icon>
                                    </v-btn>
                                </template>
                                <template #[`item.missing_quantity`]="{item}">
                                     <span :class="item.accentClass">
                                        {{
                                             item.total_quantity - item.pivot.loaded_quantity
                                         }}
                                     </span>
                                </template>
                                <template slot="no-data">
                                    <span class="message-table">
                                        {{ $t("tours.no_missing_products") }}
                                    </span>
                                </template>
                            </v-data-table>
                        </v-col>
                        <v-col cols="12" md="3">
                            <span class="libelle">
                                {{ $tc("tours.loading_comment", 1) }}
                            </span>
                            <span v-if="tour.anomaly" class="content">
                                {{ tour.anomaly.comment }}
                            </span>
                            <span v-else class="content no-data">
                                {{ $t('tours.no_comment') }}
                            </span>
                        </v-col>
                        <v-col cols="12" md="3">
                            <span class="libelle">
                                {{ $t("tours.photo") }}
                            </span>
                            <span
                                v-if="tour.anomaly && tour.anomaly.picture_path"
                                class="content">
                                 <img
                                     :src="tour.anomaly.picture_path"
                                     class="anomaly-picture"
                                     @click="openNewTab(tour.anomaly.picture_path)">
                            </span>
                            <span v-else class="content no-data">{{
                                    $t("tours.no_photo")
                                }}</span>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import loading_states from "../../mixins/loading_states";
import {
    TOUR_DELIVERY_ACTION,
    TOUR_COLLECT_ACTION
} from "../../constants";

export default {
    name: "ComponentLoad",
    mixins: [loading_states],
    props: {
        tour: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            expanded: null,
            headers: [
                {
                    text: this.$t("tours.designation"),
                    align: "start",
                    sortable: true,
                    value: "label",
                },
                {
                    text: this.$t("tours.wording_packaging"),
                    align: "start",
                    sortable: true,
                    value: "packaging",
                },
                {
                    text: this.$t("tours.expected_quantity"),
                    align: "start",
                    sortable: true,
                    value: "total_quantity",
                },
                {
                    text: this.$t("tours.missing_quantity"),
                    align: "start",
                    sortable: true,
                    value: "missing_quantity",
                },
            ],
            items: [],
            loadings: [],
            sortBy: ['pivot.type', 'label'],
            sortDesc: [false, false],
        };
    },
    computed: {
        missing_loadings() {
            if (this.tour.missing_loadings === null || this.loadings.length === 0)
                return []

            return this.tour.missing_loadings.map(product => {
                product.bgClass = "";
                product.accentClass = "";
                let missing = this.loadings.find(product_loading =>
                    product_loading.id ===
                    product.id)

                if (!missing) {
                    product.total_quantity = 0
                    product.bgClass = "bg-non-blocking-anomaly";
                    product.accentClass = "missing";
                    return product
                }

                product.total_quantity = missing.quantity
                if (product.pivot.loaded_quantity !== missing.quantity) {
                    product.bgClass = "bg-non-blocking-anomaly";
                    product.accentClass = "missing";
                }

                return product
            })
        }
    },
    mounted() {
        if (this.tour.missing_loadings)
            this.getTourLoading()
    },
    methods: {
        async getTourLoading() {
            this.loadings =
                (await this.$api.tour_loadings.get(this.tour.id)).data.products
        },
        getRowBgClass(item) {
            return item.bgClass;
        },
        openNewTab(path) {
            window.open(path, "_blank")
        },
    }
};
</script>
